<!-- all Topics section start -->
<div class="SLV2-section-wrap lr-no-padding with-btm-border" *ngIf="tabPracticeTopicData?.length > 0">
    <div class="SLV2-section-head-section">
        <h3 class="SLV2-section-heading">All Topics</h3>
        <button class="SLV2-viewall-link" (click)="navigateToPracticeTopics()" *ngIf="InteractiveStoriesList?.length >0 || pypData?.length >0">view all <i class="fa fa-angle-right"></i></button>
    </div>
    <div class="row _slider-row SLV2-sm-gap SLV2-leading-zero-list">
        <ng-container *ngFor="let topic of tabPracticeTopicData let i = index" >
            <!--  *ngIf="i <=2" -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-12" *ngIf="InteractiveStoriesList?.length >0 || pypData?.length >0? (i <4 ):(i <= tabPracticeTopicData?.length)"  >
                <app-practice-card [parcticeCardData]="topic"></app-practice-card>
            </div>
        </ng-container>
    </div>
</div>
<!-- all Topics section ended -->
<!-- when there is no stories -->
<ng-container *ngIf="tabPracticeTopicData?.length <= 0 && InteractiveStoriesList?.length <=0">
    <app-no-content-card></app-no-content-card>
</ng-container>
<!-- end of when there is no stories -->


<!-- interactive activities section start -->
<div class="SLV2-section-wrap lr-no-padding with-btm-border" *ngIf="InteractiveStoriesList?.length>0">
    <app-interactive-activities [storiesList]="InteractiveStoriesList"></app-interactive-activities>
</div>
<!-- interactive activities section ended -->


<!-- Previous year papers section start -->
<div class="SLV2-section-wrap lr-no-padding with-btm-border" *ngIf="pypData?.length>0">
    <div class="SLV2-section-head-section">
        <h3 class="SLV2-section-heading">Previous year papers</h3>
         <!-- <button class="SLV2-viewall-link">view all <i class="fa fa-angle-right"></i></button> -->
    </div>
    <div class="row SLV2-sm-gap">
        <div class="col-xl-4 col-lg-6 col-md-6" *ngFor="let pyp of pypData">
            <app-pyp-card [pypCardData]="pyp"></app-pyp-card>
        </div>
    </div>
</div>
<!-- Previous year papers section ended -->


<!-- Popular Books section start -->
<!-- <div class="SLV2-section-wrap lr-no-padding with-btm-border">
    <div class="SLV2-section-head-section">
        <h3 class="SLV2-section-heading">Popular Books</h3>
    </div>
    <div class="row">
        <div class="col-auto" *ngFor="let book of popularBookData">
            <app-popular-book-card [popularBookCardData]="book"></app-popular-book-card>
        </div>
    </div>
</div> -->
<!-- Popular Books section ended -->


<!-- Popular Books section start -->
<!-- <div class="SLV2-section-wrap lr-no-padding">
    <app-practice-test-card></app-practice-test-card>
</div> -->
<!-- Popular Books section ended -->
